import { type } from './colorModeActions';

export const colorModeReducer = (state = {}, action) => {
  switch (action.type) {
    case type.changeMode:
      return {
        ...state,
        mode: action.payload,
      };

    default:
      return state;
  }
};
